import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, primitives, semantic, space } from '../../theme/tokens';

export const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-start;
  gap: ${space['space-400']};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: auto auto;
    justify-content: flex-end;
    align-items: center;
    gap: ${space['space-300']};
  }
`;

export const CategoryDropdownContainer = styled.div`
  width: 100%;
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-400']};
  margin-bottom: ${space['space-400']};
`;

export const GroupHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  flex-shrink: 0;
`;

export const GroupLabel = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const GroupSubLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const GroupRule = styled.span`
  flex: 1;
  height: 1px;
  background: ${semantic.bg.surfaceSubtle};
`;

export const CompactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
